import * as wasm from '../wasm.js';
export class TokensFacade {
    constructor(sdk) {
        this.sdk = sdk;
    }
    async calculateId(contractId, tokenPosition) {
        await wasm.ensureInitialized();
        return wasm.WasmSdk.calculateTokenIdFromContract(contractId, tokenPosition);
    }
    // Queries
    async priceByContract(contractId, tokenPosition) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenPriceByContract(contractId, tokenPosition);
    }
    async totalSupply(tokenId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenTotalSupply(tokenId);
    }
    async totalSupplyWithProof(tokenId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenTotalSupplyWithProofInfo(tokenId);
    }
    async statuses(tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenStatuses(tokenIds);
    }
    async statusesWithProof(tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenStatusesWithProofInfo(tokenIds);
    }
    async balances(identityIds, tokenId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentitiesTokenBalances(identityIds, tokenId);
    }
    async balancesWithProof(identityIds, tokenId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentitiesTokenBalancesWithProofInfo(identityIds, tokenId);
    }
    async identityBalances(identityId, tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityTokenBalances(identityId, tokenIds);
    }
    async identityBalancesWithProof(identityId, tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityTokenBalancesWithProofInfo(identityId, tokenIds);
    }
    async identityTokenInfos(identityId, tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityTokenInfos(identityId, tokenIds);
    }
    async identitiesTokenInfos(identityIds, tokenId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentitiesTokenInfos(identityIds, tokenId);
    }
    async identityTokenInfosWithProof(identityId, tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentityTokenInfosWithProofInfo(identityId, tokenIds);
    }
    async identitiesTokenInfosWithProof(identityIds, tokenId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getIdentitiesTokenInfosWithProofInfo(identityIds, tokenId);
    }
    async directPurchasePrices(tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenDirectPurchasePrices(tokenIds);
    }
    async directPurchasePricesWithProof(tokenIds) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenDirectPurchasePricesWithProofInfo(tokenIds);
    }
    async contractInfo(contractId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenContractInfo(contractId);
    }
    async contractInfoWithProof(contractId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenContractInfoWithProofInfo(contractId);
    }
    async perpetualDistributionLastClaim(identityId, tokenId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenPerpetualDistributionLastClaim(identityId, tokenId);
    }
    async perpetualDistributionLastClaimWithProof(identityId, tokenId) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.getTokenPerpetualDistributionLastClaimWithProofInfo(identityId, tokenId);
    }
    // Transitions
    async mint(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenMint(options);
    }
    async burn(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenBurn(options);
    }
    async transfer(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenTransfer(options);
    }
    async freeze(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenFreeze(options);
    }
    async unfreeze(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenUnfreeze(options);
    }
    async destroyFrozen(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenDestroyFrozen(options);
    }
    async emergencyAction(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenEmergencyAction(options);
    }
    async setPrice(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenSetPrice(options);
    }
    async directPurchase(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenDirectPurchase(options);
    }
    async claim(options) {
        const w = await this.sdk.getWasmSdkConnected();
        return w.tokenClaim(options);
    }
}
